import React, { forwardRef } from 'react';
import { Button, ButtonProps } from '@mui/material';

export interface AlertNotificationButtonProps extends ButtonProps {}

/**
 * AlertNotificationButton is a proxy component to <Button variant="text" color="secondary" size="small" />
 */
export const AlertNotificationButton: React.FC<AlertNotificationButtonProps> = forwardRef((props, ref) => {
  return <Button ref={ref} variant="text" color="secondary" size="small" {...props} />;
});
